<template>
  <div>
    <template v-if="type === 'dict'">
      <div v-if="content && content.length == 1">
        <div class="intd-box" v-if="content[0].description && content[0].description != ''">
          <p>{{content[0].description}}</p>
        </div>
        <div v-html="content[0].content" v-if="content[0].content && content[0].content != ''"></div>
      </div>

      <div class="progress" v-if="content && content.length > 1">
        <div class="progress-box" v-for="(item,index) in content" :key="index">
          <i></i>
          <b>{{item.custom_time}}</b>
          <p>{{item.description}}</p>
          <a href="javascript:;" @click="showDetails(item)" style="color:#c30d23">点击查看更多</a>
        </div>
      </div>
    </template>
    <template v-else-if="type === 'progress'">
      <div class="progress" v-if="content && content.length > 0">
        <div class="progress-box" v-for="(item,index) in content" :key="index">
          <i></i>
          <b>{{item.regdate}}</b>
          <p>{{item.progress_title}}</p>
          <p style="color:#999">{{item.description}}</p>
          <template v-for="val in item.progress_pic_url">
            <viewer :images="item.progress_pic_url" style="display:inline-block">
              <img
                :src="val.url"
                alt
                style="width: 80px; height: 80px;margin-right:15px;cursor: pointer;"
              />
            </viewer>
          </template>
        </div>
      </div>
    </template>

    <template v-else-if="type === 'donation'">
      <el-table :data="content" border style="width: 100%">
        <el-table-column prop="displayname" label="捐赠人" align="center"></el-table-column>
        <el-table-column prop="donation_fee" label="捐赠金额" align="center"></el-table-column>
        <el-table-column prop="addtime" label="捐赠时间" align="center"></el-table-column>
      </el-table>
    </template>

    <el-dialog :title="info_title" :visible.sync="detailsShow" width="65%" center>
      <div v-html="info"></div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      defalut: () => []
    },
    type: {
      type: String,
      defalut: "dict"
    },
    title: {
      type: String,
      defalut: null
    }
  },

  data() {
    return {
      content: [],
      info_title: null,
      info: null, //具体详情内容
      detailsShow: false //详情弹框
    };
  },
  created() {
    this.content = this.data;
  },
  watch: {
    data: function(val) {
      this.content = val;
    }
  },
  methods: {
    showDetails(info) {
      this.info_title = info.custom_time +"  的  “" +this.title + "”  详情信息";
      this.info = info.content;
      this.detailsShow = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.intd-box {
  width: 100%;
  background-color: #f3f3f3;
  margin-bottom: 20px;
  > p {
    font-size: 14px;
    line-height: 30px;
    color: #333333;
    padding: 15px 35px;
    text-align: left;
  }
}
.progress {
  border: solid 1px #eaeaea;
  padding-top: 50px;
}
.progress-box {
  padding: 0 38px;
  position: relative;
  margin-left: 150px;
  padding-bottom: 60px;
  border-left: 1px solid #ddd;
  &:last-child {
    border-left: none;
  }
  > i {
    width: 10px;
    height: 10px;
    background-color: #cccccc;
    border-radius: 50%;
    position: absolute;
    left: 0;
    top: 0;
    transform: translate(-50%, 0);
  }
  > p {
    font-size: 16px;
    line-height: 28px;
    color: #333333;
  }
  > b {
    position: absolute;
    top: 0;
    left: -120px;
    font-weight: normal;
    text-align: center;
    width: 88px;
    height: 37px;
    line-height: 20px;
    > p {
      font-size: 16px;
      color: #999999;
      margin-bottom: 2px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Project_details/details_content.vue